// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"243":"bfd8c78d","267":"71ebef96","305":"2d3ff821","398":"228928de","432":"34c451da","510":"1c094b03","686":"652ebc23","846":"b5f0f263","869":"e11eeebd"}[chunkId] + ".chunk.css";
};